import { render, staticRenderFns } from "./benify-excel.vue?vue&type=template&id=1194c8c0&"
import script from "./benify-excel.vue?vue&type=script&lang=js&"
export * from "./benify-excel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports